// Approximate token estimation and deterministic budget overflow handling.

/** Per-purpose concurrency caps (runtime dialogue queue lives in llm/client.ts — read-only). */
export const PROMPT_CONCURRENCY_CAPS: Readonly<Record<string, number>> = {
  runtime_scene: 4,
  connected_questions: 2,
  world_devices: 1,
  assumption: 2,
  character_options: 2,
  location_summary: 2,
  missed_activity: 2,
};

export function estimateTokens(text: string): number {
  // ~4 chars per token heuristic — stable for tests.
  return Math.ceil(text.length / 4);
}

export interface BudgetOverflowResult {
  text: string;
  truncated: boolean;
  estimatedTokens: number;
  omittedSections: string[];
}

/** Deterministically trim history sections when over budget. */
export function applyInputBudget(
  sections: Array<{ key: string; text: string; priority: number }>,
  maxTokens: number,
): BudgetOverflowResult {
  const sorted = [...sections].sort((a, b) => a.priority - b.priority);
  const kept: string[] = [];
  const omitted: string[] = [];
  let used = 0;

  for (const section of sorted) {
    const cost = estimateTokens(section.text);
    if (used + cost <= maxTokens) {
      kept.push(section.text);
      used += cost;
    } else {
      omitted.push(section.key);
    }
  }

  const text = kept.join('\n\n');
  return {
    text,
    truncated: omitted.length > 0,
    estimatedTokens: estimateTokens(text),
    omittedSections: omitted,
  };
}
